<template>
    <div style="display: flex; justify-content:center">
        <img src="../assets/images/loading.gif" alt="" style="width:180px !important;"> 
    </div>
</template>